import { Chains } from '@prisma/client';
import { PublicKey } from '@solana/web3.js';

type Program = {
  programId: PublicKey;
  globalState: PublicKey;
};

export type NetworkAddresses = {
  readonly programs: {
    predictionMarket: Program;
  };
};

export const networkAddresses: Record<Chains, NetworkAddresses | undefined> = {
  SolanaDevnet: {
    programs: {
      predictionMarket: {
        programId: new PublicKey('ProPh6ruVL41JR3XXPuy6hN6TPH1ERqpWkZ9dp9YSEe'),
        globalState: new PublicKey(
          '691rWRx1UJawwEmhyx8ZAkemv4fNyckRqFUzwK5JU1Eq',
        ),
      },
    },
  },
  SolanaMainnet: {
    programs: {
      predictionMarket: {
        programId: new PublicKey('ProPh6ruVL41JR3XXPuy6hN6TPH1ERqpWkZ9dp9YSEe'),
        globalState: new PublicKey(
          '6PZKJowZMUAgxLxAJmHsrvzEL8PdXNymqYSJDwPRgh6V',
        ),
      },
    },
  },
} as const;
